import config from '../../config/config';

const { API_CATALOGUE_URL } = config;

export const catalogueApi = {
    fetchCatalogue: async () => {
        const response = await fetch(API_CATALOGUE_URL, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
    },
};